const parseParams = (data: any[]): any[] => {
  const params = data
    .filter((item: any) => item.nomeFornecedor !== 'Total')
    .map((item: any) => ({
      idFornecedor: item.estoque.produtoFornecedor.fornecedor.id,
      idEmpresa: item.estoque.idEmpresa,
      descricaoFornecedor: item.estoque.produtoFornecedor.fornecedor.descricao,
      quantidadeDesejada: item.desejada.quantidade,
      custoUnitarioEstoque: item.estoque.custoUnitario,
      fatorConversao:
        item.estoque.produtoFornecedor.unidadeFornecedor.fatorConversao,
      quantidadeRecomendada: item.valorRecomendacao
        ? item.valorRecomendacao.quantidade
        : 0,
      totalCompraRecomendada: item.compraProgramaRecomendada.totalPedidos,
      totalCompraDesejada: item.compraProgramaDesejada.totalPedidos,
      volume: item.estoque.produtoFornecedor.produto.volume.valor
    }))

  return params
}

const parseResult = (data: any[], isProgramada: boolean): any[] => {
  const result = data
    .filter((item: any) =>
      isProgramada
        ? item.nomeFornecedor !== 'Total'
        : item.nomeFornecedor !== ''
    )
    .map((item: any) => ({
      'fornecedor-id': item.idFornecedor === 0 ? '' : item.idFornecedor,
      'fornecedor-nome': item.nomeFornecedor,
      'recomendado-valor': item.valorRecomendado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }),
      'desejado-valor': item.valorDesejado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }),
      'desejado-volume': item.volumeDesejado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }),
      'desejado-dif': item.diferencaValorDesejado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }),
      'desejado-faturamento-minimo':
        item.faturamentoMinimoDesejado.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
    }))

  return result
}

const formatNumberOne = (value: any) => {
  // Remove espaços extras
  let cleanValue = value?.trim()

  // Remove espaços e substitui todas as vírgulas por nada (para limpeza)
  cleanValue = cleanValue?.replace(/\s/g, '').replace(/,/g, '')

  // Insere a vírgula para duas casas decimais
  const number = parseFloat(cleanValue) / 100

  // Formata o número no padrão brasileiro
  const formatted = number.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return formatted
}

// Exemplo de uso:
export const parseResultHistoric = (data: any[]): any[] => {
  const result = data
    .map((item: any) => ({
      'fornecedor-id':
        item?.codigoFornecedor === 0 || item?.codigoFornecedor == null
          ? ''
          : Number(item.codigoFornecedor),
      'fornecedor-nome': item?.nomeFornecedor ?? '',
      'produto-id': item?.codigoMaterial ?? '',
      'produto-nome': item?.nomeMaterial ?? '',
      'info-pedido': item?.numeroPedido ?? '',
      'info-mensgaem': item?.mensagem ?? '',
      'info-quant':
        item?.quantidade != null ? formatNumber(item.quantidade) : '',
      'info-peso':
        item?.pesoBruto != null ? formatNumberOne(item.pesoBruto) : '-',
      'info-tipo': item?.tipoPedido ?? '',
      'info-rem': item?.dataRemessa ?? '',
      'info-cria': item?.dataCriacao ? formatDate(item.dataCriacao) : '',
      'info-cria-hora': item?.dataCriacao ? formatTime(item.dataCriacao) : '',
      'info-finalizacao': item?.dataAlteracao
        ? formatDate(item.dataAlteracao)
        : '',
      'centro-distribuicao': item?.codigoFornecedor ?? '',
      'centro-envio': item?.codigoLoja ?? '',
      'info-user': item?.login ?? '',
      'info-proce': item?.tipoProcesso ?? '',
      'info-id': item?.idRequestSap
        ? item.idRequestSap.split('-')[0].toUpperCase()
        : '',
      'info-status': item?.mensagem ? obterStatusProduto(item.mensagem) : '',
      'info-status-pedido':
        item?.statusPedido != null ? item.statusPedido.toString() : ''
    }))
    .sort((a, b) => {
      const aVal = Number(a['info-status-pedido']) || 0
      const bVal = Number(b['info-status-pedido']) || 0
      return bVal - aVal // maior para menor
    })

  return result
}

function formatDate(isoString: string): string {
  const date = new Date(isoString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Mês começa do 0
  const year = date.getFullYear()

  return `${day}/${month}/${year}`
}

function formatTime(isoString: string): string {
  const date = new Date(isoString)
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${hours}:${minutes}:${seconds}`
}

function convertDate(dateStr: string): string {
  if (dateStr === undefined) {
    return ''
  }
  const [day, month, year] = dateStr?.split('.')
  return `${day}/${month}/${year}`
}

function formatNumber(value: string): string {
  // Substitui a vírgula por um ponto e converte para número
  const number = parseFloat(value?.replace(',', '.'))

  // Retorna formatado com duas casas decimais
  return number.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

function getStatusMessage(code: number): string {
  switch (code) {
    case 0:
      return 'Sucesso'
    case 1:
      return 'Erro'
    case 2:
      return 'Não identificado'
    default:
      return 'Código desconhecido'
  }
}
export enum EStatusProtocoloProduto {
  NaoIdentificado = 0,
  Sucesso = 1,
  Erro = 2
}

export function obterStatusProduto(
  mensagem: string | null | undefined
): string {
  if (!mensagem || mensagem.trim() === '') {
    return 'Não identificado'
  }

  if (mensagem.toLowerCase().includes('sucesso')) {
    return 'Sucesso'
  }

  return 'Erro'
}
export default {
  parseParams,
  parseResult,
  parseResultHistoric
}
